import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const ac = axios.create({
  baseURL: process.env.REACT_APP_ACTIVECAMPAIGN_URL,
});

export const klaviyoApi = axios.create({
  baseURL: process.env.REACT_APP_KLAVIYO_API,
});

export default api;



// WEBPACK FOOTER //
// ./src/client.js